export const BurgerMenuSvg = () => {
  return (
    <svg
      width="15"
      height="11"
      viewBox="0 0 15 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Burger menu</title>
      <path
        d="M0.416504 10.1954V8.94564H14.5832V10.1954H0.416504ZM0.416504 6.12501V4.87501H14.5832V6.12501H0.416504ZM0.416504 2.05439V0.804596H14.5832V2.05439H0.416504Z"
        fill="white"
      />
    </svg>
  );
};
